import React, { useEffect, useState } from "react";
import { useId24 } from "../../../drivers/id24/Id24Provider";
import { Card, Skeleton, Table, TablePaginationConfig, Typography } from "antd";
import { LuckyManagementService } from "../services/lucky-management.service";
import { useParams } from "react-router";
import Meta from "antd/es/card/Meta";
import { loadAppConfig } from "../../../configs/app-config";

type TlistUsers = {
  id: number;
  listUsers: {
    fullName: string;
    email: string;
    phone: string;
  };
};

export const LuckyManagementWinner: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const { id } = useParams<{ id: string; agendaid: string }>();
  const [dataWinner, serDataWinner] = useState<TlistUsers[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [pagination, setPagination] = useState<{
    current: number;
    pageSize: number;
  }>({ current: 1, pageSize: 10 });

  useEffect(() => {
    loadData();
  }, [loading]);

  const loadData = async () => {
    const winners = await LuckyManagementService(apiBaseUrl).findWinnerById(id);
    serDataWinner(winners);
    setLoading(false);
  };

  const onChangeTable = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination;
    setPagination({ current: current || 1, pageSize: pageSize || 10 });
  };

  const columns = [
    {
      title: "id",
      dataIndex: "id",
      key: "id",
      width: "10%",
      render: (d: string, r: TlistUsers, index: number) => index + 1 + (pagination.current - 1) * pagination.pageSize,
    },
    {
      title: "ชื่อ",
      dataIndex: ["listUsers", "fullName"],
      key: "id",
      width: "50%",
    },
    {
      title: "อีเมล",
      dataIndex: ["listUsers", "email"],
      key: "id",
      width: "20%",
    },
    {
      title: "เบอร์โทร",
      dataIndex: ["listUsers", "phone"],
      key: "id",
      width: "20%",
    },
  ];

  return loading ? (
    <Card className="w-full">
      <Skeleton loading={loading} avatar active>
        <Meta avatar={<img src="https://joeschmoe.io/api/v1/random" alt="avatar" />} title="Card Title" description="Card description" />
      </Skeleton>
    </Card>
  ) : (
    <Card className="w-full">
      <Typography className="mb-5 text-[20px] font-bold">{`ผู้ได้รับรางวัล`}</Typography>
      <Table
        dataSource={dataWinner}
        columns={columns}
        rowKey={"id"}
        pagination={{
          ...pagination,
          defaultPageSize: 10,
          total: dataWinner.length,
          showSizeChanger: true,
        }}
        onChange={onChangeTable}
      />
    </Card>
  );
};
